import { Database, CheckCircle, AlertTriangle, Clock, EyeOff, Activity, XCircle, Ban } from "lucide-react";

const StatCard = ({ label, value, icon: Icon, color = "text-blue-400", testId }) => (
  <div className="stat-card rounded-sm p-3 sm:p-4" data-testid={testId}>
    <div className="flex items-center justify-between mb-2 sm:mb-3">
      <span className="text-[10px] font-medium tracking-wide uppercase text-zinc-500">{label}</span>
      <Icon className={`w-3.5 h-3.5 sm:w-4 sm:h-4 ${color}`} />
    </div>
    <p className="text-xl sm:text-2xl font-bold tracking-tight text-white font-mono">
      {typeof value === 'number' ? value.toLocaleString() : value}
    </p>
  </div>
);

export const StatsWidgets = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2 sm:gap-3" data-testid="stats-widgets">
      <StatCard label="Total" value={stats.total} icon={Database} color="text-blue-400" testId="stat-total" />
      <StatCard label="Active" value={stats.done} icon={CheckCircle} color="text-emerald-400" testId="stat-done" />
      <StatCard label="Pending" value={stats.pending} icon={Clock} color="text-amber-400" testId="stat-pending" />
      <StatCard label="Crawling" value={stats.crawling} icon={Activity} color="text-cyan-400" testId="stat-crawling" />
      <StatCard label="Rejected" value={stats.rejected || 0} icon={Ban} color="text-orange-400" testId="stat-rejected" />
      <StatCard label="Errors" value={stats.error} icon={AlertTriangle} color="text-red-400" testId="stat-errors" />
      <StatCard label="Hidden" value={stats.hidden} icon={EyeOff} color="text-zinc-400" testId="stat-hidden" />
      <StatCard label="Rate/hr" value={stats.crawl_rate_per_hour || 0} icon={XCircle} color="text-violet-400" testId="stat-rate" />
    </div>
  );
};
